import { extendTheme } from "@chakra-ui/react";
import tinycolor from "tinycolor2"

// const em = (px: number) => `${px / 16}em`
const rem = (px: number) => ({ [px]: `${px / 16}rem` })
// const px = (num: number) => ({ [num]: `${num}px` })
const spread = (num: number) => ({ [`${num}`]: `${num}` })

const spacing = {
  '0': '0',
  ...rem(1),
  ...rem(2),
  ...rem(4),
  ...rem(5),
  ...rem(6),
  ...rem(8),
  ...rem(10),
  ...rem(12),
  ...rem(16),
  ...rem(18),
  ...rem(20),
  ...rem(22),
  ...rem(24),
  ...rem(28),
  ...rem(32),
  ...rem(36),
  ...rem(40),
  ...rem(48),
  ...rem(52),
  ...rem(56),
  ...rem(60),
  ...rem(64),
  ...rem(72),
  ...rem(80),
  ...rem(96),
  ...rem(108),
  ...rem(120),
  ...rem(128),
  ...rem(150),
  ...rem(160),
  ...rem(168),
  ...rem(200),
  ...rem(232),
  ...rem(240),
  ...rem(248),
  ...rem(256),
  ...rem(280),
  ...rem(300),
  ...rem(320),
  ...rem(400),
  ...rem(600),
  ...rem(720),
  ...rem(780),
  ...rem(840)
}

export const theme = extendTheme({
  colors: {
    yellow: "#FFDD17",
    blue: "#19A8E0",
    red: "#EF596F",
    green: "#38C656",
    pink: "#FF9CA8",
    turquoise: "#1ED6C9",
    midnight: "#09223A",
    lightGrey: "#FAFAFA",
    mediumGrey: "#CCD5DF",
    steel: "#5C6C80",
    sky: "#C9EBF5",
    sponsorsCustom: "var(--sponsors-custom-color)",
    newblue: "#1C437E",
  },
  fonts: {
    body: "Encode Sans, sans-serif",
    heading: "brandon-grotesque, sans-serif",
    live: "brandon-grotesque, sans-serif"
  },
  fontSizes: {
    ...rem(10),
    ...rem(12),
    ...rem(14),
    ...rem(16),
    ...rem(18),
    ...rem(20),
    ...rem(22),
    ...rem(24),
    ...rem(26),
    ...rem(28),
    ...rem(30),
    ...rem(36),
  },
  fontWeights: {
    ...spread(100),
    ...spread(200),
    ...spread(300),
    ...spread(400),
    ...spread(500),
    ...spread(600),
    ...spread(700),
    ...spread(800),
    ...spread(900),
    hairline: '100',
    thin: '200',
    light: '300',
    normal: '400',
    medium: '500',
    semibold: '600',
    bold: '700',
    extrabold: '800',
    black: '900',
  },
  space: spacing,
  sizes: {
    ...spacing,
    max: "max-content",
    min: "min-content",
    full: "100%",
  },
  lineHeights: {
    normal: "normal",
    none: 1,
    heading: "1.43",
    body: "1.25",
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: "700",
      },
    },
    Link: {
      baseStyle: {
        color: "#0a51d4",
        textDecoration: "underline",
      }
    },
    Image: {
      defaultProps: {
        loading: "lazy"
      }
    }
  }
})
